import { render, staticRenderFns } from "./IdentificationChecksRegistry.vue?vue&type=template&id=99494de2&scoped=true"
import script from "./IdentificationChecksRegistry.vue?vue&type=script&lang=js"
export * from "./IdentificationChecksRegistry.vue?vue&type=script&lang=js"
import style0 from "./IdentificationChecksRegistry.vue?vue&type=style&index=0&id=99494de2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99494de2",
  null
  
)

export default component.exports